export default __webpack_public_path__ + "static/media/pos-default.de55ceed.jpg";